import React from 'react';
import { Handle, Position } from 'reactflow';
import { GitBranch } from 'lucide-react';

const ConditionNode = ({ data }) => {
  return (
    <div className="bg-yellow-100 border-2 border-yellow-400 rounded-lg p-4 min-w-[200px]">
      <Handle 
        type="target" 
        position={Position.Top} 
        className="!w-4 !h-4 !bg-yellow-500 !border-2 !border-white"
        style={{ top: -8 }}
      />
      <div className="flex items-center gap-2 mb-2">
        <GitBranch size={20} className="text-yellow-600" />
        <div className="font-semibold text-yellow-900">Condition</div>
      </div>
      <div className="text-sm text-yellow-700">
        {data.conditions?.length > 0 
          ? `${data.conditions.length} condition(s)` 
          : 'No conditions set'}
      </div>
      {/* Multiple outputs for different conditions */}
      <Handle 
        type="source" 
        position={Position.Bottom} 
        id="true"
        className="!w-4 !h-4 !bg-green-500 !border-2 !border-white"
        style={{ left: '30%', bottom: -8 }}
      />
      <Handle 
        type="source" 
        position={Position.Bottom} 
        id="false"
        className="!w-4 !h-4 !bg-red-500 !border-2 !border-white"
        style={{ left: '70%', bottom: -8 }}
      />
    </div>
  );
};

export default ConditionNode;
